<template>
  <div class="map-draw-container">
    <div ref="map" class="map-box" />
    <div v-if="false" class="debug-box">
      <button @click="handleDebug">
        测试按钮
      </button>
    </div>
    <SearchInput v-if="editable" class="search-box" @select="mapAnimateTo" />
    <div v-if="editable" class="operate-box">
      <van-button v-show="status==='start'" native-type="button" icon="plus" type="primary" size="small" round @click="startDraw">
        开始绘制
      </van-button>
      <van-button v-show="status==='draw'" native-type="button" icon="passed" type="primary" size="small" round @click="endDraw">
        结束绘制
      </van-button>
      <van-button v-show="status!=='start'" native-type="button" icon="delete" type="danger" size="small" round @click="clearDraw">
        清除
      </van-button>
      <van-button v-show="status==='drawEnd'" native-type="button" icon="star" size="small" round @click="dialog.color=true">
        选择颜色
      </van-button>
      <van-button v-show="status==='drawEnd'" native-type="button" type="primary" size="small" round @click="handleConfirm">
        保存
      </van-button>
    </div>
    <iframe
      src="javascript:(function(){ window.navigator.geolocation.getCurrentPosition(function(position){parent && parent.locationCallback && parent.locationCallback(position);}, function(err){parent && parent.locationCallbackErr && parent.locationCallbackErr(err);}, {enableHighAccuracy : true, maximumAge : 30000, timeout :12000});})()"
      style="display:none;"
    />

    <van-button v-show="editable" plain type="primary" size="small" round icon="location" native-type="button" class="location-btn" @click="getLocation" />
    <color-palette
      :visible.sync="dialog.color"
      :color.sync="color"
      @change="handleChangeColor"
    />
    <div v-show="!editable" class="mask" />
  </div>
</template>

<script>
import * as maptalks from 'maptalks'
import 'maptalks/dist/maptalks.css'
import ColorPalette from '@/components/public/WhMapDraw/ColorPalette'
import SearchInput from '@/components/public/WhMapDraw/SearchInput'
import { mapCenter, mapZoom } from '@/constant/common'

export default {
  name: 'WhMapDraw',
  components: { SearchInput, ColorPalette },
  props: {
    geometryJSON: {
      type: String,
      default: undefined
    },
    editable: {
      type: Boolean,
      default: true
    },
    mapCenter: {
      type: Array,
      default() {
        return mapCenter
      }
    }
  },
  data() {
    return {
      mapZoom,
      dialog: {
        color: false
      },
      status: 'start',
      color: '#00FF00',
      map: undefined,
      drawLayer: undefined,
      pointList: [],
      drawTool: undefined,
      message: undefined,
      drawGeometry: undefined,
      iframeLocation: {}
    }
  },
  watch: {
    geometryJSON: {
      handler() {
        if (this.map === undefined) {
          this.$nextTick(() => {
            this.initMap()
          })
        } else {
          this.drawArea()
        }
      },
      immediate: true
    }
  },
  created() {
    window.locationCallback = (position) => {
      this.iframeLocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
    }
    window.locationCallbackErr = (err) => {
      console.error(err)
    }
  },
  methods: {
    initMap() {
      this.map = new maptalks.Map(this.$refs.map, {
        center: this.mapCenter,
        // pitch: 45,
        zoom: mapZoom,
        // minZoom: 10,
        // maxZoom: 18,
        // 边界限定
        // maxExtent: new maptalks.Extent(107.1616482640876, 31.064838749208178, 108.64342926994686, 31.836872151475546),
        // 缩放控件
        // zoomControl: this.editable ? { position: { left: '20', bottom: '60' }} : false,
        // 双击缩放
        doubleClickZoom: false,
        // 比例尺
        scaleControl: this.editable ? { containerClass: 'scale-container' } : false,
        attribution: false,
        baseLayer: new maptalks.GroupTileLayer('GoogleBase', [
          new maptalks.TileLayer('satellite', {
            // urlTemplate: 'https://mt{s}.google.cn/vt/lyrs=s@126&hl=zh-CN&gl=cn&src=app&s=G&x={x}&y={y}&z={z}',
            // h =仅限道路 m =标准路线图 p =地形 r =某种改变的路线图 s =仅限卫星 t =仅限地形 y =杂种
            // urlTemplate: 'https://map.snkoudai.com/maps/vt/lyrs=s&hl=zh-CN&gl=cn&scale=1&x={x}&y={y}&z={z}'
            urlTemplate: 'https://map.whhda.xyz/gmap?x=[x]&y=[y]&z=[z]',
            subdomains: ['0', '1', '2', '3']
            // zIndex: 2
          })
        ]),
        layers: [
          // 高德路网图层
          new maptalks.TileLayer('AmapRoad', {
            urlTemplate: 'http://wprd0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}',
            subdomains: ['1', '2', '3', '4'],
            maxZoom: 18,
            // zIndex: 3
            opacity: 0.7
          })
        ]
      })
      // 区域边界线
      // new maptalks.VectorLayer('xhOutLine', outline).addTo(this.map)
      // 标点图层
      // this.markerLayer = new maptalks.VectorLayer('markerLayer').addTo(this.map)
      // 编辑图层
      this.drawLayer = new maptalks.VectorLayer('drawLayer').addTo(this.map)
      // 绘图工具
      this.drawTool = new maptalks.DrawTool({
        mode: 'Polygon',
        symbol: {
          lineColor: '#00FF00',
          lineWidth: 4,
          polygonFill: '#00FF00',
          polygonOpacity: 0.2
        },
        once: true
      }).addTo(this.map).disable()
      // 添加展示geometry并适应展示
      this.drawArea()
      this.map.on('click', (e) => {
        if (this.drawTool.isEnabled()) {
          const point = new maptalks.Marker(e.coordinate, {
            'symbol': {
              'markerType': 'ellipse',
              'markerFill': 'rgb(135,196,240)',
              'markerFillOpacity': 1,
              'markerLineColor': '#34495e',
              'markerLineWidth': 2,
              'markerLineOpacity': 1,
              'markerLineDasharray': [],
              'markerWidth': 16,
              'markerHeight': 16,
              'markerDx': 0,
              'markerDy': 0,
              'markerOpacity': 1
            }
          })
          point.addTo(this.drawLayer)
          this.pointList.push(point)
        }
        // console.log(e)
        // console.log(e.coordinate)
        // console.log(e.target.getZoom(), e.target.getCenter())
      })
    },
    drawArea() {
      this.drawLayer.clear()
      if (this.geometryJSON) {
        this.drawGeometry = maptalks.Geometry.fromJSON(JSON.parse(this.geometryJSON))
        this.drawLayer.addGeometry(this.drawGeometry)
        this.map.fitExtent(this.drawGeometry.getExtent(), -0.1)
        if (this.editable) {
          this.drawGeometry.startEdit()
          this.color = this.drawGeometry.getSymbol().lineColor
          this.dialog.color = true
        }
        this.status = 'drawEnd'
      }
    },
    startDraw() {
      this.status = 'draw'
      this.drawTool.enable()
      this.message = this.$toast({
        type: 'warning',
        position: 'top',
        duration: 0,
        message: '点击地图开始绘制,双击或点击结束绘制按钮结束',
        className: 'draw-tip',
        getContainer: () => this.$el
      })
      this.drawTool.once('drawend', (param) => {
        // 清空点
        this.pointList.forEach(i => {
          i.remove()
        })
        this.pointList = []
        this.message.clear()
        if (!param.geometry.getArea()) {
          this.$toast('请至少选择三个点绘制完整的面')
          this.status = 'start'
          return
        }
        this.drawGeometry = param.geometry
        this.drawLayer.addGeometry(this.drawGeometry)
        this.drawGeometry.startEdit()
        this.dialog.color = true
        this.status = 'drawEnd'
      })
    },
    endDraw() {
      this.drawTool.endDraw()
    },
    clearDraw() {
      this.pointList = []
      this.message ? this.message.clear() : ''
      this.drawTool.disable()
      this.drawLayer.clear()
      this.status = 'start'
    },
    mapAnimateTo({ center, zoom = mapZoom }) {
      this.map.animateTo({
        center,
        zoom,
        pitch: 0
        // bearing: 20
      }, {
        duration: 1000
      })
    },
    handleChangeColor(color) {
      this.drawGeometry.updateSymbol({
        lineColor: color,
        polygonFill: color
      })
    },
    handleConfirm() {
      this.drawGeometry.endEdit()
      // this.drawLayer.clear()
      this.$emit('change', {
        geometryJSON: this.drawGeometry.toJSON(),
        area: this.drawGeometry.getArea()
      })
      this.status = 'start'
    },
    handleDebug() {
      console.log(1)
    },
    getLocation() {
      if (this.$store.state.AMap) {
        const toast = this.$toast.loading({
          message: '定位中...'
        })
        if (this.iframeLocation && this.iframeLocation.lng && this.iframeLocation.lat) {
          this.mapAnimateTo({
            center: [this.iframeLocation.lng, this.iframeLocation.lat]
          })
          toast.clear()
        } else {
          this.$store.state.geolocation.getCurrentPosition((status, result) => {
            console.log(result)
            const { position } = result
            if (status === 'complete') {
              this.mapAnimateTo({
                center: [position.lng, position.lat]
              })
            }
            toast.clear()
          })
        }
      } else {
        this.$toast.fail('定位组件加载中...')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.map-draw-container {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.location-btn {
  position: absolute;
  bottom: 60px;
  left: 10px;
}
.search-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.map-box {
  height: 100%;
}
::v-deep {
  .draw-tip {
    top: 85px;
    width: auto;
    height: auto;
    min-width: auto;
    min-height: auto;
  }
  .van-toast__text {
    margin: 0;
  }
}
::v-deep {
  .scale-container {
    border: 2px solid #fff;
    border-top: none;
    text-align: center;
    color: #fff;
  }
}
.operate-box {
  position: absolute;
  bottom: 10px;
  right: 10px;
  .van-button + .van-button {
    margin-left: 10px;
  }
}
.mask {
  position: absolute;
  z-index: 20;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.debug-box {
  position: absolute;
  top: 200px;
  left: 10px;
  background: #fff;
  z-index: 100;
}
</style>
